"use client";

import { BrandProvider, ColorModeProvider, NoticeProvider } from "@texturehq/edges";
import { ApolloProviderWrapper } from "@/components/ApolloProviderWrapper";
import { ErrorBoundary } from "@/components/ErrorBoundary/ErrorBoundary";
import { AuthProvider } from "@/providers/AuthProvider";
import { UserProvider } from "@/providers/UserProvider";

const ADMIN_BRAND_VARIABLES = {
  "--color-brand-primary": "#0f766e",
  "--color-brand-dark": "#115e59",
};

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <ErrorBoundary level="page" title="Application Error">
      <ColorModeProvider>
        <BrandProvider variables={ADMIN_BRAND_VARIABLES}>
          <NoticeProvider>
            <AuthProvider>
              <ApolloProviderWrapper>
                <UserProvider>{children}</UserProvider>
              </ApolloProviderWrapper>
            </AuthProvider>
          </NoticeProvider>
        </BrandProvider>
      </ColorModeProvider>
    </ErrorBoundary>
  );
}
